import { render, staticRenderFns } from "./FreightTableRouteTaxes.vue?vue&type=template&id=bded2850&scoped=true"
import script from "./FreightTableRouteTaxes.vue?vue&type=script&lang=js"
export * from "./FreightTableRouteTaxes.vue?vue&type=script&lang=js"
import style0 from "./FreightTableRouteTaxes.vue?vue&type=style&index=0&id=bded2850&prod&scoped=true&lang=less"
import style1 from "./FreightTableRouteTaxes.vue?vue&type=style&index=1&id=bded2850&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bded2850",
  null
  
)

export default component.exports